import { useState, useMemo } from 'react';
export var useToggle = function (initialState) {
    if (initialState === void 0) { initialState = false; }
    var _a = useState(initialState), state = _a[0], setState = _a[1];
    var handlers = useMemo(function () { return ({
        on: function () {
            setState(true);
        },
        off: function () {
            setState(false);
        },
        toggle: function () {
            setState(function (s) { return !s; });
        },
        reset: function () {
            setState(initialState);
        },
    }); }, [initialState]);
    return [state, handlers];
};
